import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-device-screenshot-zoom-dialog',
  templateUrl: './device-screenshot-zoom-dialog.component.html',
  styleUrls: ['./device-screenshot-zoom-dialog.component.scss']
})
export class DeviceScreenshotZoomDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<DeviceScreenshotZoomDialogComponent>) { }

  ngOnInit() {
  }

}
